import { Pipe, PipeTransform } from '@angular/core';
import { ThumbnailSize } from '../enums/thumbnail-size.enum';
import { FileUtils } from '../utils/file-utils';

@Pipe({
  name: 'imageKeyFormat',
  standalone: true
})
export class ImageKeyFormatPipe implements PipeTransform {

  transform(imageKey: string, size: ThumbnailSize = ThumbnailSize.S): string {
    if (!imageKey) {
      return '';
    }

    let result = imageKey;
    result = this.encodeImageKey(result);
    result = this.addParams(result, size);
    return result;
  }

  private encodeImageKey(imageKey: string): string {
    return FileUtils.encodeDocumentKey(imageKey);
  }

  private addParams(imageKey: string, size: ThumbnailSize): string {
    return `${imageKey}${size ? `?thumbnail=${size}` : ''}`;
  }

}
